import { List, Create, Edit, Barcode } from "../Components/index.js";

export default [
    {
        path: "/admin/setting/parade-state-approval",
        component: List,
        name: "admin-settings-parade-state",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/parade-state/create",
        component: Create,
        name: "admin-settings-parade-state-create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/parade-state/:id/edit",
        component: Edit,
        name: "admin-settings-parade-state-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/parade-state-code",
        component: Barcode,
        name: "admin-settings-parade-state-code",
        meta: {
            requiresAuth: true,
        },
    },
];
